import { BaseError } from "./BaseError";
import { ValidationError } from "./ValidationError";

export class AggregateValidationError extends Error {
  private static readonly DEFAULT_MESSAGE: string = "Multiple Errors";

  errorList: BaseError[] = [];
  invalidModel: any;

  constructor(errors: ValidationError[], invalidModel?: any) {
    super(AggregateValidationError.DEFAULT_MESSAGE);
    this.errorList = errors;
    this.invalidModel = invalidModel;
  }
}
